import { generateRequest } from '.';
import { toQueryString } from '../../lib/utils/querystring';

export const Action = {
  Fuels: {
    FuelsPending: 'Fuels_PENDING',
    FuelsCompleted: 'Fuels_FULFILLED',
    FuelsFailed: 'Fuels_FAILED',
  },
};

export const fetchFuels = stationIds => generateRequest({
  endpoint: `/assets-v2/api/fuels?${toQueryString({ stationIds })}`,
  types: [
    Action.Fuels.FuelsPending,
    Action.Fuels.FuelsCompleted,
    Action.Fuels.FuelsFailed,
  ].map(actionType => ({ type: actionType, meta: { stationIds } })),
});

export const fetchFuelsByStation = stationId => generateRequest({
  endpoint: `/assets-v2/api/stations/${stationId}/fuels`,
  types: [
    Action.Fuels.FuelsPending,
    Action.Fuels.FuelsCompleted,
    Action.Fuels.FuelsFailed,
  ].map(actionType => ({
    type: actionType,
    meta: { station_id: stationId },
  })),
});
